import { createFileRoute } from "@tanstack/react-router";

import { ComputeResourceManagementPage } from "@/routes/compute-resource-management";

export const Route = createFileRoute("/crm")({
  head: () => ({ meta: [{ title: "CRM · GENRL Wallet" }] }),
  component: ComputeResourceManagementPage,
});
